import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

const OrderSuccessPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Перенаправляем на главную через 5 секунд
    const timer = setTimeout(() => {
      navigate('/');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <article className="flex w-0 flex-1 flex-col items-center justify-center gap-6 py-10">
      <div className="text-center">
        <h1 className="mt-4 text-2xl font-semibold">Заказ успешно оформлен!</h1>
        <p className="mt-2 text-gray-600">
          Спасибо за ваш заказ. Мы свяжемся с вами в ближайшее время для подтверждения.
        </p>
        <p className="mt-4 text-sm text-gray-500">
          Через 5 секунд вы будете перенаправлены на главную страницу...
        </p>
      </div>
    </article>
  );
};

export default OrderSuccessPage; 